module.exports = __webpack_public_path__ + "img/jauneMouvement.1cf5765c.png";